/**
 * Configuration du thème de l'application
 * Modifiez ces valeurs pour changer la couleur primaire du site
 */

export const themeConfig = {
  colors: {
    primary: {
      // Valeurs RGB (sans les guillemets et parenthèses pour CSS)
      // Exemple: pour rgb(37, 99, 235), écrivez: '37 99 235'
      rgb: '13 110 253', // Couleur primaire principale (Bootstrap #0d6efd)
      rgbHover: '11 94 215', // Couleur au survol (Bootstrap #0b5ed7)
      
      // Exemples de couleurs alternatives:
      // Rouge: '239 68 68' et '220 38 38'
      // Vert: '34 197 94' et '22 163 74'
      // Violet: '168 85 247' et '147 51 234'
      // Orange: '251 146 60' et '249 115 22'
    }
  }
};

/**
 * Convertit les valeurs RGB en objet { r, g, b }
 */
export const getPrimaryColorRGB = () => {
  const [r, g, b] = themeConfig.colors.primary.rgb.split(' ').map(Number);
  return { r, g, b };
};

/**
 * Retourne la couleur primaire au format rgb(r, g, b)
 */
export const getPrimaryColorString = () => {
  const { r, g, b } = getPrimaryColorRGB();
  return `rgb(${r}, ${g}, ${b})`;
};

